export const WelcomeStepBundle = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&',
  },

  template: `
    <div class="welcome-step-bundle">
      <welcome-step-nutrition
        ng-hide="$ctrl.isComplete"
        member="$ctrl.member"
        is-loading="$ctrl.isLoading"
        on-update="$ctrl.onUpdate({ key: key, value: value })"
        on-submit="$ctrl.scrollTo({ id: '' }); $ctrl.isComplete = true;"
        scroll-to="$ctrl.scrollTo({ id: id })">
        <welcome-step-actions
          on-cancel="$ctrl.onCancel()"
          is-loading="$ctrl.isLoading">
          Done
        </welcome-step-actions>
      </welcome-step-nutrition>
      <welcome-step-workout
        ng-show="$ctrl.isComplete"
        member="$ctrl.member"
        is-loading="$ctrl.isLoading"
        on-update="$ctrl.onUpdate({ key: key, value: value })"
        on-submit="$ctrl.onSubmit({ data: data })"
        scroll-to="$ctrl.scrollTo({ id: id })">
        <welcome-step-actions
          on-cancel="$ctrl.onCancel()"
          is-loading="$ctrl.isLoading">
          Let's Start
        </welcome-step-actions>
      </welcome-step-workout>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepBundle.js